import { datadogRum } from '@datadog/browser-rum';

const initExternalApis = () => {
  try {
    datadogRum.init({
      applicationId: '7691a35e-fb81-4353-8c23-dca5b6c722a5',
      clientToken: 'pub513e3ea4b8bc9a37071620ba7a42f284',
      site: 'datadoghq.com',
      service:'api-docs',
      sampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel:'mask-user-input',
      env: process.env.NODE_ENV,
      version: process.env.REACT_APP_VERSION,
    });
    datadogRum.startSessionReplayRecording();
    console.log('Datadog session recording is active');
  } catch (err) {
    console.error(err);
  }
}

export default initExternalApis;
